module.exports = __webpack_public_path__ + "static/CircularStd-Bold-99b65ddd1a9540f024f76c12e6372393.woff2";